import { render, staticRenderFns } from "./BotonesProcesoCaptura.vue?vue&type=template&id=2a9f4532&"
import script from "./BotonesProcesoCaptura.vue?vue&type=script&lang=js&"
export * from "./BotonesProcesoCaptura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports